import ProductsAdminPage from "./ProductsAdminPage";

export default ProductsAdminPage;
